// 加盟店種別一覧のラベル
export const LABELS = {
  MERCHANT_TYPE_REGISTRATION: "加盟店種別登録",
  TITLE: "加盟店種別一覧",
  TYPE_NO: "種別No",
  TYPE_NAME: "種別名",
  ADDRESS_MANAGEMENT_FLAG: "住所管理要否",
  STORE_INFORMATION_AGGREGATION_TARGET_FLAG: "店舗情報集約",
  FAKE_INDUSTRY_CHECK_FLAG: "偽業態チェック",
  STORE_APPLICATION_FORM: "店舗申請様式",
  TENANT_EXAMINATION_FLAG: "店子審査要否",
  TENANT_EXAMINATION_UNIT: "店子審査単位",
  APPLICABLE_START_DATE: "適用開始日",
  APPROVAL_STATUS: "ステータス",
  TABLE_TITLE: "加盟店種別",
};

// フラグ表示項目
interface FlagDisplayObj {
  trueText: string;
  falseText: string;
}

// フラグ表示パターンインターフェース
export interface FlagDisplayPattern {
  isRequired: FlagDisplayObj;
  isTarget: FlagDisplayObj;
}

// フラグ表示項目パターン
export const flagDisplayPattern: FlagDisplayPattern = {
  isRequired: {
    trueText: "要",
    falseText: "不要",
  },
  isTarget: {
    trueText: "対象",
    falseText: "対象外",
  },
};

// 画面表示するフラグ項目の取得
export const getFlagDisplayText = (
  flg: boolean,
  pattern: keyof FlagDisplayPattern
): string => {
  const patternObj: FlagDisplayObj = flagDisplayPattern[pattern];

  let flagDisplayText: string;

  if (flg) {
    flagDisplayText = patternObj.trueText;
  } else {
    flagDisplayText = patternObj.falseText;
  }

  return flagDisplayText;
};
